import { NarwhalDto } from '../../../api/narwhalDto';
import { NarwhalService } from '../../../narwhal.service';
import { Component, OnInit, HostListener, EventEmitter, Output, ElementRef, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { defs } from '../../../defs';
import { OfferDto } from '../../../api/offerDto';

@Component({
	selector: 'narwhalia-narwhal-sell-popup',
	templateUrl: './narwhal-sell-popup.component.html',
	styleUrls: ['./narwhal-sell-popup.component.scss']
})
export class NarwhalSellPopupComponent implements OnInit {
	form: FormGroup;
	@Input() narwhal: NarwhalDto;
	@Output() closePopup: EventEmitter<boolean>;
	@Output() startSell: EventEmitter<OfferDto>;
	@HostListener('document:click', ['$event'])
	clickedOutside(event) {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.closePopup.emit(true);
		}
	}

	constructor(private fb: FormBuilder, private elementRef: ElementRef, private narwhalService: NarwhalService) {
		this.form = this.fb.group({
			startPriceFormControl: ['', [Validators.required, Validators.min(0)]],
			endPriceFormControl: ['', [Validators.required, Validators.min(0)]],
			periodFormControl: ['', [Validators.required, Validators.min(1)]]
		});
		this.closePopup = new EventEmitter<boolean>();
		this.startSell = new EventEmitter<OfferDto>();
	}

	ngOnInit() {}

	offerNarwhal() {
		this.narwhalService
			.offerNarwhal( new OfferDto(
				this.form.get('startPriceFormControl').value,
				this.form.get('periodFormControl').value * defs.dayToMinutes,
				this.form.get('endPriceFormControl').value),
				this.narwhal.id
			)
			.then(price => {
				this.closePopup.emit(true);
				this.startSell.emit(price);
			});
	}
}